import { types, utils } from "@vilocnv/allsetra-core";

export function mapObjectToMarker(
  object: types.IObject
): types.MarkerType | undefined {
  const {
    location,
    uniqueId = "",
    direction = 0,
    objectType,
    name = ""
  } = object;

  if (!location) return;

  const { latitude, longitude } = location;
  if (!latitude || !longitude || latitude === 0 || longitude === 0) {
    return;
  }

  const position = {
    lat: latitude - 0.00001,
    lng: longitude
  };
  const iconUrl = objectType?.icon?.url ?? "";
  const icon = utils.getMapIcon(
    iconUrl,
    direction === 0 ? object?.lastReportedDirection : direction
  );

  return {
    uniqueId,
    position,
    icon,
    direction,
    name
  };
}
